import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// material
import {
  Button,
  Card,
  Checkbox,
  Container,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  Select,
  MenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
import { NOT_AVAILABLE } from '../Global/Constants';
import Loader from '../Global/Loader';
import { fDate, fDateNew, fDateTime2 } from '../../utils/formatTime';
import LeadsToolbar from './LeadsToolbar';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import { getLeadGridData, getLeadListStatus } from '../../store/Slice/Lead/LeadSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';
import {
  getCityData,
  getInternalSaleManager,
  getLoanTypeData,
  getMasterListType
} from '../../store/Slice/Global/GlobalSlice';
import { isValidValue, normalizeValue } from '../../utils/CommonFunction';
import leadsService from '../services/leadsService';
import useDebounce from '../../utils/useDebounce';

const { AssignLeads } = leadsService;

const TABLE_HEAD = [
  { id: 'leadId', label: 'LEAD ID', alignRight: false },
  { id: 'created', label: 'LEAD DATE', alignRight: false },
  { id: 'name', label: 'CUSTOMER NAME', alignRight: false },
  { id: 'loanType', label: 'LOAN TYPE', alignRight: false },
  { id: 'users', label: 'CITY', alignRight: false },
  { id: 'amount', label: 'AMOUNT', alignRight: false },
  { id: 'leadSource', label: 'LEAD SOURCE', alignRight: false },
  { id: 'statusLeads', label: 'STATUS', alignRight: false },
  { id: 'applicantType', label: 'APPLICANT TYPE', alignRight: false },
  { id: 'created', label: 'LAST UPDATE', alignRight: false },
  { id: 'action', label: 'ACTION', alignRight: false, align: 'center' }
];

// ----------------------------------------------------------------------

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fafbfc'
  },
  '&:hover': {
    backgroundColor: '#f1f5f9 !important'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 11.5,
    padding: '12px 14px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#64748b',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e2e8f0',
    letterSpacing: '0.5px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px 14px',
    borderBottom: '1px solid #f1f5f9',
    color: '#334155'
  }
}));

/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function Leads() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page1, setPage1] = useState(1);
  const [selectProduct, setSelectProduct] = useState(' ');
  const [selectStatus, setSelectStatus] = useState(' ');
  const [selectSource, setSelectSource] = useState(' ');
  const [selectLeadSource, setSelectLeadSource] = useState(' ');
  const [pageMenu, setPageMenu] = useState([]);
  const [stateListMenu, setStateListMenu] = useState([]);
  const [cityListData, setCityListData] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openAssign, setOpenAssign] = useState(false);
  const [assignValue, setAssignValue] = useState(' ');
  const [validationMsg, setValidationMsg] = useState('');
  const [alertMsg, setAlertMsg] = useState(false);
  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [hasNextPage, setHasNextPage] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const debouncedSearch = useDebounce(filterName, 1000);

  const { LoginData } = useLoginSelector();
  const { LeadGridData } = useLeadSelector();
  const leadsListResponse = LeadGridData || [];
  // console.log('leadsListResponse22', leadsListResponse);
  const totalCount = leadsListResponse?.length || 0;

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = leadsListResponse
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // source leads field
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // select product field
  const handleSelectProduct = (e) => {
    setSelectProduct(e.target.value);
  };

  // select status
  const handleSelectStatus = (e) => {
    setSelectStatus(e.target.value);
  };

  // select source
  const handleSelectSource = (e) => {
    setSelectSource(e.target.value);
  };

  const handleSelectLeadSource = (e) => {
    setSelectLeadSource(e.target.value);
  };

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - leadsListResponse.length) : 0;

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleAssignSubmit = async (e) => {
    if (assignValue === ' ') {
      setAlertMsg(true);
      return true;
    }
    const newArray = [];
    selected.forEach((item) => {
      const obj = {
        leadId: item.leadId,
        stageId: 56,
        leadStageStatusId: item.leadStageStatusId,
        assignedTo: assignValue
      };
      newArray.push(obj);
    });
    const credential = {
      assignableLeads: newArray
    };

    const AssignLeadsApiResponse = await AssignLeads(credential, LoginData?.jwt);
    if (AssignLeadsApiResponse.msg) {
      if (AssignLeadsApiResponse.msg === 'Forbidden') {
        navigate('/');
      }
    }
    if (AssignLeadsApiResponse.status === 'success') {
      navigate('/leads');
      setAssignValue(' ');
      setOpenAssign(false);
      getLeadListApi(); // get latest update list
      setSelected([]);
    } else {
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
      setOpenAssign(false);
    }
  };

  useEffect(() => {
    const leadDetails = localStorage.getItem('leadDetails');
    const allDocumentList = localStorage.getItem('allDocumentList');
    if (allDocumentList !== null) {
      localStorage.removeItem('allDocumentList');
    }

    if (leadDetails !== null) {
      localStorage.removeItem('leadDetails');
    }
    setTimeout(() => {
      localStorage.removeItem('fromRecommendationTab');
    }, 1000);
  }, []);

  // lead list
  const getLeadListApi = useCallback(() => {
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      stageId: 56,

      leadFilterModel: {
        fromLeadDate:
          filterDatesRange[0].startDate !== null ? fDateTime2(filterDatesRange[0].startDate) : null,
        toLeadDate:
          filterDatesRange[0].endDate !== null ? fDateTime2(filterDatesRange[0].endDate) : null,
        leadStatusId: selectStatus !== ' ' ? selectStatus : null,
        campaignSourceId: selectSource !== ' ' ? selectSource : null,
        leadRouteTypeId: selectLeadSource !== ' ' ? selectLeadSource : null,
        cityId: cityListData === null ? null : cityListData.cityId,
        loanTypeId: selectProduct !== ' ' ? selectProduct : null
      },

      entityListRequestModel: {
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        pageSize: rowsPerPage,
        pageNumber: page + 1,
        sortOrder: order
      }
    };

    dispatch(getLeadGridData(credentials));
  }, [
    LoginData,
    filterDatesRange,
    selectStatus,
    selectSource,
    rowsPerPage,
    page,
    order,
    selectProduct,
    selectLeadSource,
    cityListData,
    debouncedSearch
  ]);

  //  city api
  const handleGetState = (optionVal) => {
    const data = {
      stateId: optionVal
    };
    dispatch(getCityData(data)); // city data
  };

  // internal sale manager list
  const getInternalSaleManagerData = useCallback(() => {
    if (!LoginData?.companyId) return; // safety check
    const data = {
      companyId: LoginData?.companyId
    };
    dispatch(getInternalSaleManager(data));
  }, [LoginData]);

  // lead list status
  const getLeadListStatusApi = () => {
    const credential = {
      stageId: 56
    };
    dispatch(getLeadListStatus(credential));
  };

  // Master Type List
  const getMasterTypeListApi = () => {
    const type = 'LEAD_ROUTE_TYPE';
    dispatch(getMasterListType(type));
  };

  // loan type
  const getLoanMasterApi = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData]);

  useEffect(() => {
    getLeadListApi(); // call center list
    getLoanMasterApi(); // loan master list
    getLeadListStatusApi(); // lead list status
    getMasterTypeListApi(); // Master Type List
    getInternalSaleManagerData(); // Internal Sales Manager Data
    handleGetState(null); // get city list
  }, [getLeadListApi]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setHasNextPage(true);
  };

  useEffect(() => {
    if (leadsListResponse?.length < rowsPerPage) {
      setHasNextPage(false); // last page reached
    } else {
      setHasNextPage(true);
    }
  }, [leadsListResponse, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  return (
    <Page title="Partner Management System || Leads">
      <Container maxWidth="xl" sx={{ pb: 6, pt: 2 }}>
        {/* Top Header Row with Icon, Title, and Breadcrumb */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          sx={{ mb: 3.5, gap: 2 }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: '12px',
                bgcolor: '#e0f2fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0284c7'
              }}
            >
              <LeaderboardOutlinedIcon sx={{ fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: '#0f172a',
                  fontSize: { xs: '20px', sm: '24px' },
                  letterSpacing: '-0.3px',
                  mb: 0.25
                }}
              >
                Leads
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '13px' }}>
                Manage and assign customer leads across products and regions.
              </Typography>
            </Box>
          </Stack>

          <Box>
            <BrudCrumbs />
          </Box>
        </Stack>

        <Card
          sx={{
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            overflow: 'hidden',
            bgcolor: '#ffffff'
          }}
        >
          <LeadsToolbar
            numSelected={selected.length}
            filterName={filterName}
            setFilterName={setFilterName}
            onFilterName={handleFilterByName}
            selectProduct={selectProduct}
            setSelectProduct={setSelectProduct}
            onFilterProduct={handleSelectProduct}
            selectStatus={selectStatus}
            setSelectStatus={setSelectStatus}
            onFilterStatus={handleSelectStatus}
            selectSource={selectSource}
            setSelectSource={setSelectSource}
            onFilterSource={handleSelectSource}
            selectLeadSource={selectLeadSource}
            setSelectLeadSource={setSelectLeadSource}
            onFilterLeadSource={handleSelectLeadSource}
            parent="leads"
            selected={selected}
            pageMenu={pageMenu}
            stateListMenu={stateListMenu}
            filterDatesRange={filterDatesRange}
            setFilterDatesRange={setFilterDatesRange}
            cityListData={cityListData}
            setCityListData={setCityListData}
            onAssignSubmit={handleAssignSubmit}
            openAssign={openAssign}
            setOpenAssign={setOpenAssign}
            assignValue={assignValue}
            setAssignValue={setAssignValue}
            validationMsg={validationMsg}
            setValidationMsg={setValidationMsg}
            alertMsg={alertMsg}
            setAlertMsg={setAlertMsg}
            leadsListResponse={leadsListResponse}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, minHeight: 380, overflow: 'auto' }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={leadsListResponse?.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  isCheckBox="true"
                />
                <TableBody>
                  {leadsListResponse && leadsListResponse.length > 0
                    ? leadsListResponse?.map((item, index) => {
                        const isItemSelected = selected.indexOf(item) !== -1;
                        return (
                          <StyledTableRow
                            hover
                            key={index}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell padding="checkbox" sx={{ pl: 2.5 }}>
                              <Checkbox
                                checked={isItemSelected}
                                onChange={(event) => handleClick(event, item)}
                                sx={{
                                  color: '#cbd5e1',
                                  '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: '#0284c7' }
                                }}
                              />
                            </TableCell>
                            <StyledTableCell
                              align="left"
                              sx={{ fontWeight: 600, color: '#0284c7' }}
                            >
                              {item.leadId ? item.leadId : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                              {isValidValue(item.leadDate)
                                ? fDate(item.leadDate)
                                : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              sx={{ fontWeight: 600, color: '#0f172a' }}
                            >
                              {item.customerName ? item.customerName : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                              {item.loanType ? item.loanType : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                              {item.city ? item.city : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              sx={{ fontWeight: 600, color: '#0f172a' }}
                            >
                              {item.loanAmountRequested
                                ? item.loanAmountRequested
                                : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                              {item.leadRouteTypeName ? item.leadRouteTypeName : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <Label
                                variant="ghost"
                                color={
                                  (item.stageStatusName === 'New' && 'greymsg') ||
                                  (item.stageStatusName === 'Contacted' && 'greymsg') ||
                                  (item.stageStatusName === null && 'error') ||
                                  (item.stageStatusName === 'Not Interested' && 'error') ||
                                  (item.stageStatusName === 'Not Contactable' && 'greymsg') ||
                                  (item.stageStatusName === 'Partial Complete' && 'greymsg') ||
                                  (item.stageStatusName === 'Completed' && 'success') ||
                                  (item.stageStatusName === 'Submitted' && 'success') ||
                                  'warning'
                                }
                                sx={{ textTransform: 'capitalize' }}
                              >
                                {item.leadStatus ? item.leadStatus : `${NOT_AVAILABLE}`}
                              </Label>
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                              {normalizeValue(item?.employmentType, `${NOT_AVAILABLE}`)}
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                              {normalizeValue(
                                fDateNew(item?.leadLastUpdatedOn),
                                `${NOT_AVAILABLE}`
                              )}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <UserMoreMenu
                                rowId={item.leadId}
                                assignedTo={item.assignedTo}
                                parent="leads"
                                companyId={item.companyId}
                                applicationId={item.applicationId}
                                itemObj={item}
                              />
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })
                    : ''}
                </TableBody>
                {leadsListResponse?.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <StyledTableCell
                        align="center"
                        colSpan={TABLE_HEAD.length + 1}
                        sx={{ py: 3 }}
                      >
                        <SearchNotFound searchQuery={filterName} />
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          {/* Modern Pagination Footer */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            sx={{ p: 2, px: 3, borderTop: '1px solid #f1f5f9', bgcolor: '#ffffff', gap: 2 }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Typography sx={{ fontSize: '13px', color: '#64748b' }}>Showing</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#0f172a' }}>
                {leadsListResponse?.length || 0} records
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography sx={{ fontSize: '13px', color: '#64748b' }}>
                Page <span style={{ fontWeight: 600, color: '#0f172a' }}>{page + 1}</span>
              </Typography>

              <Stack direction="row" spacing={1}>
                <IconButton
                  disabled={page === 0}
                  onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                  sx={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    p: 0.75,
                    bgcolor: '#ffffff',
                    color: '#0f172a',
                    '&.Mui-disabled': { opacity: 0.4, bgcolor: '#f8fafc' }
                  }}
                >
                  <ChevronLeftIcon sx={{ fontSize: 18 }} />
                </IconButton>
                <IconButton
                  disabled={!hasNextPage}
                  onClick={() => setPage((prev) => prev + 1)}
                  sx={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    p: 0.75,
                    bgcolor: '#ffffff',
                    color: '#0f172a',
                    '&.Mui-disabled': { opacity: 0.4, bgcolor: '#f8fafc' }
                  }}
                >
                  <ChevronRightIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
        </Card>
        <Loader openLoader={openLoader} />

        <ApiErrorMessage
          openApiError={openApiError}
          setOpenApiError={setOpenApiError}
          errorMessage={errorMessage}
        />
      </Container>
    </Page>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ paddingTop: '1rem' }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
